export default __webpack_public_path__ + "media/images/banners/months/bnr_4-157097f45e7e305d3de201f80a3bb11c.jpg";